module.exports = __webpack_public_path__ + "img/NETWORK NAME.6467f750.svg";